import Input from "../../../components/Input/Input";
import Checkbox from "../../../components/Checkbox/Checkbox";
import {ReactComponent as InfoSvg} from "../../../assets/info.svg";
import Icon from "../../../components/Icon/Icon";
import {inputTypeOptions} from "../Elements/Settings/Settings";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import CustomCreatableSelect from "../../../components/CustomCreatableSelect/CustomCreatableSelect";
import classNames from "classnames";
import {useFormik} from "formik";

const InputModal = ({handleChange, localSettings, modalRadioGroups, setModalRadioGroups, error}) => {
    const mapToVariable = (title) => {
        localSettings.variables = title.toLowerCase().replaceAll(" ", "_");
    }

    return (
        <>
            <CustomSelect
                id="inputType"
                label="Input type"
                value={inputTypeOptions.find(option => option.value === (localSettings.inputType || "Number"))}
                options={inputTypeOptions}
                onChange={(selectedOption) => handleChange("inputType", selectedOption.value)}
            />

            <div>
                <Input
                    name="title"
                    label="Title"
                    className="modal"
                    value={localSettings.title || ""}
                    onChange={(e) => {
                        handleChange("title", e.target.value)
                        mapToVariable(e.target.value);
                    }}
                    error={error === "Title is required" && error}
                />
            </div>

            {localSettings.inputType === "select" &&
                <CustomCreatableSelect
                    id="options"
                    label="Options"
                    placeholder="Add options"
                    value={localSettings.options}
                    options={localSettings.options}
                    onChange={(options) => handleChange("options", options)}
                    required={true}
                    isMulti={true}
                    error={error === "Options are required" && error}
                />
            }

            {localSettings.inputType === "radio" &&
                <CustomCreatableSelect
                    id="radioGroup"
                    label="Group name"
                    placeholder="Add group name"
                    value={modalRadioGroups.find(option => option.value === localSettings.selectedRadioGroup.value)}
                    options={modalRadioGroups}
                    onChange={(radioGroup) => {
                        if (radioGroup && !modalRadioGroups.find(option => option === radioGroup))
                            setModalRadioGroups(prev => [...prev, radioGroup])

                        handleChange("selectedRadioGroup", radioGroup);
                    }}
                    required={true}
                    isMulti={false}
                    error={error === "Group name is required" && error}
                />
            }

            <div>
                <Input name="description"
                       label="Description"
                       required={false}
                       className="modal"
                       value={localSettings.description || ""}
                       onChange={(e) => handleChange("description", e.target.value)}
                />
            </div>

            <div className="variables">
                <Checkbox
                    label="Variables"
                    variant={classNames("checkmark", "dark")}
                    name="hasVariable"
                    value={localSettings.hasVariable}
                    onChange={(e) => handleChange("hasVariable", e.target.checked)}
                    checked={localSettings.hasVariable}
                />

                <div className="tooltip">
                    <Icon svg={InfoSvg} className="icon"/>
                    <span className="triangle"></span>
                    <span className="text">Automatically fills this field in future forms for the same client.</span>
                </div>
            </div>

            {localSettings.hasVariable && (
                <div>
                    <Input
                        name="variables"
                        className={classNames("modal", "has-variable")}
                        value={localSettings.variables || ""}
                        required={false}
                        readOnly={true}
                        error={error}
                    />
                </div>
            )}

            <div>
                <Checkbox
                       label="Required"
                       variant={classNames("checkmark", "dark")}
                       value={localSettings.required}
                       onChange={(e) => handleChange("required", e.target.checked)}
                       checked={localSettings.required}
                />
            </div>
        </>
    )
}

export default InputModal;